import { marked } from 'marked';

marked.use({
  renderer: {
    image(href, title, text) {
      const iframeMatch = text.match(/iframe/i);
      if (iframeMatch) {
        const [width, height] = title.split('x');
        let sanitizedHref = href;
        return `<iframe src="${sanitizedHref}" width="${width}" height="${height}" frameborder="1" allowfullscreen></iframe>`;
      }
      return `<img src="${href}" alt="${text}" title="${title}" />`;
    },
    list(body, isOrdered, start) {
      if (isOrdered) {
        const startAttr = start !== 1 ? `start="${start}"` : '';
        return `<ol ${startAttr}>\n${body}</ol>\n`;
      }

      const taskListAttr = body.startsWith('<li data-task-list-item ') ? 'data-task-list' : '';
      return `<ul ${taskListAttr}>\n${body}</ul>\n`;
    },
    listitem(text, isTask, isChecked) {
      if (!isTask) {
        return `<li>${text}</li>\n`;
      }

      const checkedAttr = isChecked ? 'data-checked' : '';
      return `<li data-task-list-item ${checkedAttr}>${text}</li>\n`;
    },
  },
});

function markdownToHtml(markdown, sanitizer) {
  const html = marked(markdown, { gfm: true, smartLists: true, xhtml: true, breaks: true });

  if (sanitizer) return (html = sanitizer(html));

  return html;
}

export default markdownToHtml;
